import { render, staticRenderFns } from "./OsQuestionnairePage.vue?vue&type=template&id=6b646fe0&scoped=true"
import script from "./OsQuestionnairePage.vue?vue&type=script&lang=ts"
export * from "./OsQuestionnairePage.vue?vue&type=script&lang=ts"
import style0 from "./OsQuestionnairePage.vue?vue&type=style&index=0&id=6b646fe0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b646fe0",
  null
  
)

export default component.exports